import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import { fetchSettings } from './reducer/actions';
import { getShopBrandId, isBrandViewActive } from '../../../auth/selectors';

const mapStateToProps = state => ({
  brandId: getShopBrandId(state),
  isBrandUser: isBrandViewActive(state),
  loadingShopifySettings: state.shopify.shopifySettings.loading,
  shopifySettings: state.shopify.shopifySettings.settings,
  shopifyConnectionState: state.shopify.shopifyConnectionState,
});

const mapDispatchToProps = {
  fetchSettings,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.fetchSettings(this.props.brandId);
    },
  }),
);
